import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    newSegment: {
        isLoading: false,
        data: null,
        error: null
    },
    targetCustomerCount: null,
    customerCountLoading: false,
    customerCountError: null
};

const createSegmentSlice = createSlice({
    name: 'CreateSegment',
    initialState,
    reducers: {
        createNewSegment: (state) => {
            state.newSegment.isLoading = true;
        },
        createNewSegmentSuccess: (state, action) => {
            state.newSegment.isLoading = false;
            state.newSegment.data = action.payload;
        },
        // Use the PayloadAction type to declare the contents of `action.payload`
        createNewSegmentError: (state, action) => {
            state.newSegment.isLoading = false;
            state.newSegment.error = action.payload.message;
        },
        getCustomerCount: (state, action) => {
            state.customerCountLoading = true;
            state.targetCustomerCount = null;
        },
        setTargetCustomerCount: (state, action) => {
            state.targetCustomerCount = action.payload;
            state.customerCountLoading = false;
        },
        getCustomerCountError: (state, action) => {
            state.customerCountLoading = false;
            state.customerCountError = action.payload;
        }
    },
});

export const {
    createNewSegment,
    createNewSegmentSuccess,
    createNewSegmentError,
    setTargetCustomerCount,
    getCustomerCount,
    getCustomerCountError,
} = createSegmentSlice.actions;

export default createSegmentSlice.reducer;
